<div class="wrap">
  <mat-card class="item_actu_item">
    <ion-thumbnail slot="start" class="img_card">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-thumbnail>

    <mat-card-content class="item_content">
      <div class="hashtag " style="display: flex;">
        <ion-skeleton-text animated style="width:  15%; margin-right: 5px;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width:  15%"></ion-skeleton-text>
      </div>
      <h1>
        <ion-skeleton-text animated style="width: 75%"></ion-skeleton-text>
      </h1>
      <p class="infos">
        <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
      </p>
      <p class="infos">
        <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
      </p>
      <p class="infos">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </p>
      <div class="more">
        <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
      </div>

    </mat-card-content>
  </mat-card>
  <mat-card class="item_actu_item">
    <ion-thumbnail slot="start" class="img_card">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-thumbnail>

    <mat-card-content class="item_content">
      <div class="hashtag " style="display: flex;">
        <ion-skeleton-text animated style="width:  15%; margin-right: 5px;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width:  15%"></ion-skeleton-text>
      </div>
      <h1>
        <ion-skeleton-text animated style="width: 75%"></ion-skeleton-text>
      </h1>
      <p class="infos">
        <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
      </p>
      <p class="infos">
        <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
      </p>
      <p class="infos">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </p>
      <div class="more">
        <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
      </div>

    </mat-card-content>
  </mat-card>
  <mat-card class="item_actu_item">
    <ion-thumbnail slot="start" class="img_card">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-thumbnail>

    <mat-card-content class="item_content">
      <div class="hashtag " style="display: flex;">
        <ion-skeleton-text animated style="width:  15%; margin-right: 5px;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width:  15%"></ion-skeleton-text>
      </div>
      <h1>
        <ion-skeleton-text animated style="width: 75%"></ion-skeleton-text>
      </h1>
      <p class="infos">
        <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
      </p>
      <p class="infos">
        <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
      </p>
      <p class="infos">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </p>
      <div class="more">
        <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
      </div>
    </mat-card-content>
  </mat-card>

</div>